/*
 * auth (provider)
 */
import { Session } from "@supabase/supabase-js"
import React, { useEffect, useState } from "react"
import { AuthContext } from "./auth.context"
import supabase from "./services/supabase"

type AuthProviderProps = {
	children: React.ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
	const [session, setSession] = useState<Session | null>(null)
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		supabase.auth.getSession().then(({ data: { session } }) => {
			setSession(session)
			setIsLoading(false)
		})

		const {
			data: { subscription },
		} = supabase.auth.onAuthStateChange(async (_, session) => {
			setSession(session)
			setIsLoading(false)
		})

		return () => {
			subscription.unsubscribe()
		}
	}, [])

	async function signOut() {
		await supabase.auth.signOut()
	}

	return (
		<AuthContext.Provider
			value={{ session, user: session?.user ?? null, signOut, isLoading }}
		>
			{children}
		</AuthContext.Provider>
	)
}
